// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
// Components
import { Button } from '@/common-utils/components/ui/button';
import ModalLegalInfos from './ModalLegalInfos';
// Common
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import Permissions from '@/app/permissions/Permissions';

/**
 * @param root0
 * @param root0.registrationNumber
 * @returns {JSX} LegalInfosCell
 */
function LegalInfosCell({ registrationNumber }) {
    // Store
    const { permissions } = useSessionStore(s => s.session);

    // State
    const [showModalLegalInfos, setShowModalLegalInfos] = useState(false);

    const handleShowModalLegalInfos = () => {
        const hasCompanyInfosReadPermissions = hasRequiredPermissions({
            permissions,
            requiredPermissions: [Permissions.COMPANY_INFOS_READ.name]
        });
        return hasCompanyInfosReadPermissions ? setShowModalLegalInfos(true) : null;
    };
    return (
        <>
            <Button onClick={handleShowModalLegalInfos} className='text-sm' variant='link' entity={registrationNumber} />
            {
                showModalLegalInfos && <ModalLegalInfos registrationNumber={registrationNumber} isOpen={showModalLegalInfos} setIsOpen={setShowModalLegalInfos} />
            }
        </>
    );
}

export default LegalInfosCell;

LegalInfosCell.propTypes = {
    registrationNumber: PropTypes.string
};